exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".preview-dialog{position:fixed;top:0;left:0;z-index:9;width:100%;height:100%}.preview-dialog .s1-preview-image{width:auto;max-width:100%;max-height:100%;display:inline-block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/PreviewImage/style.scss
// module id = 1930
// module chunks = 33